import { render, staticRenderFns } from "./LicenseForm.vue?vue&type=template&id=3f7f6790&scoped=true&"
import script from "./LicenseForm.vue?vue&type=script&lang=js&"
export * from "./LicenseForm.vue?vue&type=script&lang=js&"
import style0 from "./LicenseForm.vue?vue&type=style&index=0&id=3f7f6790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7f6790",
  null
  
)

export default component.exports